import React from 'react';
import { Space, Select } from 'antd';
import { Globe } from 'lucide-react';
import { useLanguage, Language } from '../context/LanguageContext';

const LanguageSelector: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (value: string) => {
    setLanguage(value as Language);
  };

  return (
    <Space className="language-selector">
      <Globe className="w-4 h-4 text-gray-500" />
      <Select
        value={language}
        onChange={handleLanguageChange}
        bordered={false}
        dropdownMatchSelectWidth={false}
        className="language-select"
        size="small"
        options={[
          { value: 'english', label: 'English' },
          { value: 'hindi', label: 'हिंदी' },
          { value: 'marathi', label: 'मराठी' },
        ]}
      />
    </Space>
  );
};

export default LanguageSelector;
